import auth_manage from "./auth_manage";
import organization from "./organization";
import auth_client from "./auth_client";

export default [...auth_manage, ...organization, ...auth_client];
